module.exports = __webpack_public_path__ + "static/img/2.751bd7d4.png";